import { Typography } from "antd";
import styled from "styled-components";

import FlexContainer from "@/components/FlexContainer";

export const AuthWrapper = styled(FlexContainer)`
    padding-top: 24px;
`;

export const ForgetPasswordWrapper = styled(FlexContainer)`
    padding-top: 16px;
`;

export const StyledLink = styled(Typography)`
    text-align: center;
    cursor: pointer;
    font-size: 14px;
`;
